import React from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import {
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Button
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';




const styles = theme => ({
  changePasswordButton: {
    margin: '10px 0'
  }
});

const UserInfo = props => {
  const { onChange, id, firstName, lastName, email, onChangePasswordClick, profile, mode } = props;

  const classes = useClasses(styles);
  return (
    <React.Fragment>
      <CardHeader
        title={profile ? 'Profile' : 'Member Info'}
      />
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="First Name"
              margin="dense"
              name="firstName"
              onChange={(event) => onChange(event, 'firstName')}
              required
              value={firstName || ''}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="Last Name"
              margin="dense"
              name="lastName"
              onChange={(event) => onChange(event, 'lastName')}
              required
              value={lastName || ''}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="Email Address"
              margin="dense"
              name="email"
              onChange={(event) => onChange(event, 'email')}
              required
              value={email || ''}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            {mode !== 'add' ? (
              <Button sx={{
                margin: '10px 0',
                padding: '5px 15px'
              }} variant="contained" color="secondary" onClick={event => onChangePasswordClick(event, IDBFactory)}>
                Change Password
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </CardContent>
    </React.Fragment>
  );
};

export default withErrorHandler(UserInfo, axios)